// extracted by mini-css-extract-plugin
export default {"blockBannerBox":"BlockBanner_blockBannerBox__By1OM","directorBox":"BlockBanner_directorBox__QUhP-","contactUsBox":"BlockBanner_contactUsBox__Qal+2"};